/**
 * @fileoverview
 * Route path segments for non-audit features. Use with APP_ROUTE_PATHS for
 * navigation in components (score-card, score-card-builder, settings, online,
 * query-management, asset-management sub-features).
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

/** Score card */
export const SCORE_CARD_ROUTE = {
  AUDIT_SCORE_CARD: 'audit-score-card',
} as const;

/** Score card builder */
export const SCORE_CARD_BUILDER_ROUTE = {
  SCORING_MODEL: 'scoring-model',
  PARAMETERS: 'parameters',
  RULE_CONFIGURATION: 'rule-configuration',
} as const;

/** Settings */
export const SETTINGS_ROUTE = {
  AUDIT_SCHEDULE: 'audit-schedule',
  EDIT: 'edit',
  VIEW: 'view',
  ALL: 'all',
  DYNAMIC_FORM: 'dynamic-form',
  FORM_CREATION_PROCESS: 'form-creation-process',
  NEW_FORM: 'new-form',
  PREVIEW: 'preview',
} as const;

/** Query management */
export const QUERY_MANAGEMENT_ROUTE = {
  QUERY_DETAILS: 'query-details',
} as const;

/** Online (release, kyc-and-disbursement) */
export const ONLINE_ROUTE = {
  RELEASE: 'release',
  KYC_AND_DISBURSEMENT: 'kyc-and-disbursement',
  ALL: 'all',
  LOAN_LIST: 'loan-list',
  DEAL_VIEWER: 'deal-viewer',
  DEAL_MOVEMENT: 'deal-movement',
  KYC_DETAILS: 'kyc-details',
} as const;

/** Asset management sub-features (vault-key-entry, key-movement, asset-entry) */
export const ASSET_MANAGEMENT_SEGMENTS = {
  VAULT_KEY_ENTRY: 'vault-key-entry',
  NEW_VAULT_KEY_ENTRY: 'new-vault-key-entry',
  ACKNOWLEDGE: 'acknowledge',
  KEY_MOVEMENT_SENDER: 'key-movement-sender',
  KEY_MOVEMENT_RECEIVER: 'key-movement-receiver',
  KEY_MOVEMENT_SENDER_AUDIT: 'key-movement-sender-audit',
  KEY_MOVEMENT_RECEIVER_VARIANCE: 'key-movement-receiver-variance',
  KEY_MOVEMENT_RECEIVER_AUDIT_ACKNOWLEDGE: 'key-movement-receiver-audit-acknowledge',
  ASSET_ENTRY: 'asset-entry',
  ADD: 'add',
} as const;
